<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title align-items-center mb-4">
            {{ $t('Treasury.global') }}
          </h1>
        </div>
      </div>

      <div class="d-flex align-items-start justify-content-between">
        <div>
          <h2 class="level-two-title bold-text secondary-color">{{ $t('Treasury.month',{mois :new Date().toLocaleString('fr', { month: 'long' })}) }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardValues[0])"
            background-color="treso"
            title="treasury.card.title.treso"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardValues[1])"
            background-color="investisseurs"
            title="treasury.card.title.investisseurs"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardValues[2])"
            background-color="emprunts"
            title="treasury.card.title.emprunts"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(-cardValues[3])"
            background-color="emprunts"
            title="treasury.card.title.emprunts.authorized"/>
        </div>
      </div>

      <div class="mt-2 flex-row d-flex justify-content-end">
        <div>
          <b-button class="btn-medium m-2" variant="outline-primary" @click="clickOnTreasuryHistoryBtn">
            {{ this.$t('treasury.history') }}
          </b-button>
          <b-button class="btn-medium m-2" variant="primary" @click="clickOnTreasuryEditBtn">
            {{ this.$t('treasury.new') }}
          </b-button>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="m-2 d-flex">
          <b-button class="btn-medium ml-2" style="padding:5px !important;" variant="primary" @click="decrementYear">
            <chevron-left-icon size="14"/>
          </b-button>
          <h1 class="page-title ml-3 mr-3 align-self-center"> {{ $t('Year.x', {year: year}) }}</h1>
          <b-button class="btn-medium" style="padding:5px !important;" variant="primary" @click="incrementYear">
            <chevron-right-icon size="14"/>
          </b-button>
        </div>
        <treasury-global-column ref="treasuryChart"
                                :key="year"
                                :card-values="cardValues"
                                :end-of-year="endOfYear"
                                :start-of-year="startOfYear"
                                @updateCardValues="updateCardValues">
        </treasury-global-column>


        <div class="mt-2" style="margin: 2px 5px;"><span class="apexcharts-legend-marker legend-item" style="background: rgb(109, 132, 196) !important; color: rgb(109, 132, 196);"></span><span class="text-legend">{{$t('Treasury.global.explanation.legend')}}</span></div>
        <div class="mt-2" style="margin: 2px 5px;"><span class="apexcharts-legend-marker legend-item" style="background: rgb(6, 201, 179) !important; color: rgb(6, 201, 179);"></span><span class="text-legend">{{$t('Treasury.investor.global.explanation.legend')}}</span></div>
        <div class="mt-2" style="margin: 2px 5px;"><span class="apexcharts-legend-marker legend-item" style="background: rgb(158, 4, 48) !important; color: rgb(158, 4, 48);"></span><span class="text-legend">{{$t('Treasury.bankcredit.global.explanation.legend')}}</span></div>
        <div class="mt-2" style="margin: 2px 5px;"><span class="apexcharts-legend-marker legend-item" style="background: rgb(58, 77, 128) !important; color: rgb(58, 77, 128);"></span><span class="text-legend">{{$t('Treasury.solde.global.explanation.legend')}}</span></div>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import TreasuryChart from "./TreasuryChart";
import TreasuryGlobalColumn from "./TreasuryGlobalColumn";
import TreasuryCardComponent from "../../components/TreasuryCardComponent.vue";

export default {
  name: "TreasuryIndex",


  components: {
    B122Table,
    ItemDeleteModal,
    TreasuryChart,
    TreasuryGlobalColumn,
    TreasuryCardComponent
  },

  data() {
    return {
      username: this.$store.getters.username,
      treasuryMovementId: null,
      cardValues: [0, 0, 0, 0], // Valeurs mises à jour dans le composant TreasuryChart
      year: null,
      startOfYear: null,
      endOfYear: null,
      currentYear: new Date().getFullYear(),
    }
  },

  watch: {
    'year': async function () {
      this.startOfYear = new Date(this.year, 0, 1).getTime();

      this.endOfYear = new Date(this.year, 11, 31, 23, 59, 59, 999).getTime();

      await this.$refs.treasuryChart.fetchData()
    }
  },

  created() {
    this.setYear()
  },

  methods: {

    decrementYear() {
      this.year--
    },

    setYear() {
      this.year = new Date().getFullYear()
    },

    incrementYear() {
      this.year++
    },

    convertToEuros(value) {
      return Intl.NumberFormat().format(value) + " €"
    },

    clickOnTreasuryHistoryBtn() {
      this.$router.push({
        name: 'TreasuryHistory'
      })
    },

    clickOnTreasuryEditBtn() {
      this.$router.push({
        name: 'TreasuryCreateEdit'
      })
    },

    updateCardValues(cardValues) {
      this.cardValues = cardValues
    },

  }
}
</script>

<style scoped>
.legend-item {
  height: 12px;
  width: 12px;
  left: 0px;
  top: 0px;
  border-width: 0px;
  border-color: rgb(255, 255, 255);
  border-radius: 12px;
}

.treso-legend{
  background: rgb(109, 132, 196) !important;
  color: rgb(109, 132, 196);
}
.text-legend{
  color: var(--main-text-color);
  font-size: var(--content-font-size);
  font-family: "Montserrat-Regular", "Arial", sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/views/treasury/TreasuryIndex.vue